export default {
  cropsContext: new Map(),
  status: ""
};
